import React from 'react';
import { Link } from 'react-router-dom';
import MaintenanceBackground from '../../components/MaintenanceBackground/MaintenanceBackground';
import MountainRange from '../../components/MountainRange/MountainRange';
import StatusBadge from '../../components/StatusBadge/StatusBadge';
import './MaintenancePage.css';

/**
 * Full-screen "site under maintenance" splash page.
 * Same markup renders both the desktop and mobile layouts from the
 * design — responsiveness is handled entirely through CSS.
 */
function MaintenancePage({
  badgeLabel = 'Fuera de servicio temporalmente',
  title = 'Estamos en un proceso de mejora-this is a test',
  signature = 'Firmado el equipo de FLIK',
}) {
  return (
    <main className="MaintenancePage">
      <MaintenanceBackground />

      <div className="MaintenancePage-content">
        <StatusBadge label={badgeLabel} />
        <h1 className="MaintenancePage-title">{title}</h1>
        <span className="MaintenancePage-divider" aria-hidden="true" />
        <p className="MaintenancePage-signature">{signature}</p>

        <div className="MaintenancePage-actions">
          <Link
            className="MaintenancePage-btn MaintenancePage-btn--primary flik-cut-md"
            to="/"
          >
            Volver al inicio
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="butt"
              aria-hidden="true"
            >
              <path d="M4 12 L20 12 L14 6 M20 12 L14 18" />
            </svg>
          </Link>
          <Link
            className="MaintenancePage-btn MaintenancePage-btn--ghost flik-cut-md"
            to="/authenticate"
          >
            Ir a acceder
          </Link>
        </div>
      </div>

      <MountainRange />
    </main>
  );
}

export default MaintenancePage;
